import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import Footer from "./Footer";
import { EASE } from "./Reveal";

export const LegalSection = ({ title, children }) => (
  <section className="space-y-4">
    {title && (
      <h2 className="font-display text-lg md:text-lg font-semibold text-ecdeep tracking-tight flex items-start gap-3">
        <span className="mt-2 h-2 w-2 rounded-full bg-ecamber shrink-0" />
        {title}
      </h2>
    )}
    <div className="space-y-4 text-[15px] leading-relaxed text-slate-600">{children}</div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-3">
    {items.map((it, i) => (
      <li key={i} className="flex items-start gap-3">
        <span className="mt-[9px] h-1.5 w-1.5 rounded-full bg-ecnavy/40 shrink-0" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

export default function LegalLayout({ num, chapter, title, updated, children, testId }) {
  return (
    <div className="bg-white min-h-screen" data-testid={testId}>
      <header className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-ecnavy/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center">
            <img src="/assets/eclickgo-logo.webp" alt="eClickGo" className="h-9 w-auto" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border border-ecnavy/20 text-ecnavy text-sm font-semibold px-6 py-2.5 hover:bg-ecnavy/5 transition-colors duration-300"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={15} />
            Volver al inicio
          </Link>
        </div>
      </header>

      <main className="pt-36 md:pt-44 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE }}>
            <div className="flex items-center gap-4 mb-6">
              <span className="font-display text-sm font-semibold tracking-[0.25em] text-ecamber">{num}</span>
              <span className="h-px w-12 bg-ecnavy/20" />
              <span className="text-xs font-semibold uppercase tracking-[0.3em] text-ecnavy/60">{chapter}</span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.1] text-ecdeep">{title}</h1>
            <p className="mt-5 text-sm text-slate-500">Fecha de la última actualización: {updated}</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
            className="mt-14 space-y-12"
          >
            {children}
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
